import React from "react";
import styled from "../style.module.css";
import { GREEN, ALERT_ERROR, ALERT_WARN, ALERT_INFO } from "./theme";

// Actionable alerts row. Hidden entirely when there's nothing to act on.
const AlertStrip = ({ alerts }) => {
  if (!alerts || alerts.length === 0) {
    return (
      <div className={`${styled.alertStrip} ${styled.alertAllClear}`}>
        <span className={styled.alertDot} style={{ background: GREEN }} />
        <span>All clear — nothing needs attention right now.</span>
      </div>
    );
  }

  const color = (lvl) => (lvl === "error" ? ALERT_ERROR : lvl === "warn" ? ALERT_WARN : ALERT_INFO);

  return (
    <div className={styled.alertStrip}>
      <span className={styled.alertHeading}>Needs attention</span>
      <div className={styled.alertChips}>
        {alerts.map((a, i) => (
          <span key={i} className={styled.alertChip} style={{ "--lvl": color(a.level) }} title={a.hint || ""}>
            <span className={styled.alertDot} style={{ background: color(a.level) }} />
            {a.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AlertStrip;
